import React from 'react';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
export class GroupOperationButton extends React.Component {
    render() {
        const { className, children, onClick, disabled } = this.props;
        return /*#__PURE__*/ React.createElement(TextButton, {
            size: "small",
            variant: "main",
            className: className,
            disabled: disabled,
            onClick: onClick
        }, children);
    }
}
export default GroupOperationButton;

//# sourceMappingURL=GroupOperationButton.js.map